<template>
  <div class="rounded-lg bg-gray-900 w-full">
    <div class="m-3 bg-gray-900 flex items-center justify-between">
      <div class="flex items-center">
        <ChevronDownIcon class="h-8 w-8 p-2 mr-2 cursor-pointer inline bg-gray-800 rounded-lg transition-transform text-text-primary" />
        <div class="h-9 w-32 bg-gray-800 rounded animate-pulse" />
        <div class="ml-4 h-9 w-64 bg-gray-800 rounded animate-pulse" />
      </div>
    </div>
    <div class="md:ml-12 ml-2 mr-2">
      <h2 class="p-6 mr-1 bg-gray-800 rounded-t-lg text-gray-100" />
      <div class="p-6 mr-1 border-t border-gray-900 bg-gray-800" />
      <div class="h-2 rounded-b-lg mb-3 bg-gray-800" />
    </div>
  </div>
</template>

<script setup>
import { ChevronDownIcon } from '@heroicons/vue/24/outline';
</script>
